import type { ComponentPropsWithoutRef } from "react";
import type { Control } from "react-hook-form";
import { t } from "ttag";

import { Form, Select } from "@/shared/ui";
import type { AdminSession } from "../models";
import { SESSION_CATEGORY } from "../models";

const options = Object.entries(SESSION_CATEGORY).map(([_, value]) => ({
  value: value,
  label: value,
}));

type FieldValue = Pick<AdminSession, "category">;

type SessionCategoryControl<T> = T extends FieldValue ? Control<T> : never;

type SessionCategoryFieldProps<T extends FieldValue> = ComponentPropsWithoutRef<
  typeof Form.Item
> & {
  control: SessionCategoryControl<T>;
};

export const SessionCategoryField = <T extends FieldValue>({
  control,
  ...props
}: SessionCategoryFieldProps<T>) => {
  return (
    <Form.Field
      control={control}
      name="category"
      render={({ field: { value, ...field } }) => (
        <Form.Item {...props}>
          <Form.Label aria-required>{t`Category`}</Form.Label>
          <Form.Control>
            <Select options={options} value={value ?? ""} {...field} />
          </Form.Control>
          <Form.Message compact={false} />
        </Form.Item>
      )}
    />
  );
};
